<template>
  <div class="accordeonContainer paddingright15 fontsize16 borderGrey borderBottomWidth1 borderBottomStyleSolid" >
    <div class="displayflex flexbetween fontweight600 colorBlue cursor-pointer" style="padding:20px 0;" @click="onClick">
      <div style="width:calc(100% - 35px);">{{title}}</div>
      <SVGIcon name="icon_expand_more" :class="expanded ? 'rotate180':''" size="little"/>
    </div>
    <slot v-if="expanded" name="answer"/>
  </div>
</template>

<script>
import SVGIcon from "./SVGIcon.vue";
export default {
  name: "Accordeon",
  components: { SVGIcon },
  props: ["title"],
  data: function() {
    return {
      expanded: false
    };
  },
  methods:{
    onClick(){
      this.expanded = !this.expanded
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  margin-bottom:20px;
  padding: 0;
  padding-left: 10px;
}
ul.numbered{
  list-style:decimal inside;
  padding-left:20px;
}
ul.numbered>li:before {
  content: "";
}
ul.numbered>li{
  text-indent: -20px;
}

li:not(.numbered) { 
  text-indent: -10px;
}

li:before {
  content: "- ";
}

</style>
